export default class generalParam {
  // TODO: API経由で貰う
  // TODO: APIのIF部分が修正されているので処理要修正
  static gprList: any = {
    retry_info: {
      max_count: '10',
      interval: '3'
    },
    retry_info2: {
      max_count2: '100',
      interval2: '30'
    }
  };

  /**
   * 汎用パラメータを配列に変換
   */
  public static toArray(gpr: string): string[] {
    const res: string[] = [];
    for (const key in (<any>this.gprList)[gpr]) {
      if (key !== null) {
        res.push(<any>(<any>this.gprList)[gpr]);
        break;
      }
    }
    return res;
  }

  /**
   * 汎用パラメータの取得
   */
  public static getValue(gpr: string, name: string): string {
    return this.toArray(gpr)
      .filter((c: any) => c[name])
      .map((c: any) => c[name])
      .toString();
  }
}
